import React from 'react'
import styled from 'styled-components'

import SelectionButton from './SelectionButton'

interface IMultiSelectionButton {
  className?: string
  options: {
    key: string
    label: string
  }[]
  selectedOption: string
  changeSelectedUnit: () => void
}

const MultiSelectionButton = ({
  changeSelectedUnit,
  className,
  options,
  selectedOption,
}: IMultiSelectionButton) => (
  <Wrapper
    className={className}
    options={options}
  >
    {options.map((op) => (
      <SelectionButton
        changeSelectedUnit={changeSelectedUnit}
        key={op.key}
        key_={op.key}
        label={op.label}
        selectedOption={selectedOption}
      />
    ))}
  </Wrapper>
)

const Wrapper = styled.div<{
  className?: string
  options: { key: string; label: string }[]
}>`
  display: grid;
  grid: 1fr / repeat(${({ options }) => options.length}, 1fr);
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  min-width: default;
`

export default MultiSelectionButton
